export default "__VITE_ASSET__1a47b900__"